const states = {
  tags_details: {
    tags: [],
    loading: false,
    load_error: false
  }
}

export default states
